// compositeProperty Component
// Handles add/remove of rows for a repeatable composite property.
// The hidden <template> row uses placeholders rewritten on clone (no double underscores: those
// collide with Thymeleaf's __...__ preprocessing syntax):
//   @@I<n>@@  -> a fresh, form-global form-array index (one per sub-field)
//   @@ROW@@   -> the new row's row index (sub-field discriminator)
export default () => ({
    init() {
        this.form = this.$el.closest('form');
        this.rowsContainer = this.$refs.rowsContainer;
        this.template = this.$refs.rowTemplate || null;

        // Next row index = max existing data-row + 1 (rows are independent within this composite).
        let maxRow = -1;
        this.rowsContainer.querySelectorAll('.composite-row').forEach(row => {
            const r = parseInt(row.getAttribute('data-row'), 10);
            if (!isNaN(r) && r > maxRow) maxRow = r;
        });
        this.rowCounter = maxRow + 1;
    },

    // Reads and increments the form-global running index shared by every composite in the form.
    takeIndex() {
        const input = this.form.querySelector('.form-next-index');
        const cur = parseInt(input.value || '0', 10);
        input.value = cur + 1;
        return cur;
    },

    addRow() {
        if (!this.template) return;

        let html = this.template.innerHTML;

        // Each distinct @@I<n>@@ placeholder identifies one sub-field; give it one fresh index.
        const placeholders = [...new Set(html.match(/@@I\d+@@/g) || [])];
        placeholders.forEach(ph => {
            html = html.split(ph).join(this.takeIndex());
        });
        html = html.split('@@ROW@@').join(this.rowCounter++);

        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const row = tmp.querySelector('.composite-row');
        if (row) this.rowsContainer.appendChild(row);
    },

    handleRemoveRow(event) {
        const btn = event.target.closest('.composite-remove-row');
        if (!btn) return;
        const row = btn.closest('.composite-row');
        if (row) row.remove();
    }
});
